import styled from 'styled-components';
import { StyledDisplayReviewProps } from './DisplayReview.types';

export const StyledDisplayReview = styled.div<StyledDisplayReviewProps>`
  .review__vote,
  .review__report {
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
